export { default } from "./LoginViewContainer";
export { default as i18n } from "./i18n";
export { default as reducer } from "./reducer";

import { LoginViewState as TLoginViewState } from "./types";
export type LoginViewState = TLoginViewState;
